import { useDispatch } from 'react-redux'
import { Icon } from '../../../../../../common/html/icon'
import { removeCompanyImport } from '../../../store/slice'

export const TdActionTableAddCompany = ({ rowId }) => {
  const dispatch = useDispatch()

  const handleRemove = () => {
    dispatch(removeCompanyImport(rowId))
  }

  return (
    <Icon
      className="icon-trash-fill"
      style={{ color: '#9C9C9C', fontSize: 14 }}
      onClick={handleRemove}
    />
  )
}
